import {IInsurance} from "@/model/Insurance/Insurance"

export interface IHasInsurances {
    getInsurances(): IInsurance[]
    getInsurancesMap(): Map<string, IInsurance>
    addInsurance(insurance: IInsurance): void
    removeInsurance(insurance: IInsurance): void
}

function hasInsurances<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasInsurances {
        private insurances: IInsurance[] = []
        private insurancesMap: Map<string, IInsurance> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }

        public getInsurances(): IInsurance[] {
            return this.insurances
        }
        public getInsurancesMap(): Map<string, IInsurance> {
            return this.insurancesMap
        }
        public addInsurance(insurance: IInsurance): void {
            if (this.insurancesMap.has(insurance.getIdFull())) return
            this.insurances.push(insurance)
            this.insurancesMap.set(insurance.getIdFull(), insurance)
        }
        public removeInsurance(insurance: IInsurance): void {
            if (!this.insurancesMap.has(insurance.getIdFull())) return
            this.insurances = this.insurances.filter((existingInsurance: IInsurance) => existingInsurance.getIdFull() !== insurance.getIdFull())
            this.insurancesMap.delete(insurance.getIdFull())
        }
    };
}

export default hasInsurances